import { render, staticRenderFns } from "./AwardCriteriaMapping.vue?vue&type=template&id=5d8c2d55&scoped=true"
import script from "./AwardCriteriaMapping.vue?vue&type=script&lang=js"
export * from "./AwardCriteriaMapping.vue?vue&type=script&lang=js"
import style0 from "./AwardCriteriaMapping.vue?vue&type=style&index=0&id=5d8c2d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8c2d55",
  null
  
)

export default component.exports